import { z } from 'zod'
import { decimalSchema } from '../../utils/schema'

export const spotBalanceSchema = z.object({
  coin: z.string(),
  token: z.number(),
  hold: decimalSchema,
  total: decimalSchema,
  entryNtl: decimalSchema,
})

export const perpStateSchema = z.object({
  assetPositions: z.array(
    z.object({
      position: z.object({
        coin: z.string(),
        cumFunding: z.object({
          allTime: decimalSchema,
          sinceChange: decimalSchema,
          sinceOpen: decimalSchema,
        }),
        entryPx: decimalSchema,
        leverage: z.object({
          rawUsd: decimalSchema.optional(),
          type: z.string(),
          value: z.number(),
        }),
        liquidationPx: decimalSchema.nullable().optional(),
        marginUsed: decimalSchema,
        maxLeverage: z.number(),
        positionValue: decimalSchema,
        returnOnEquity: decimalSchema,
        szi: decimalSchema,
        unrealizedPnl: decimalSchema,
      }),
      type: z.string(),
    }),
  ),
  crossMaintenanceMarginUsed: decimalSchema,
  crossMarginSummary: z.object({
    accountValue: decimalSchema,
    totalMarginUsed: decimalSchema,
    totalNtlPos: decimalSchema,
    totalRawUsd: decimalSchema,
  }),
  marginSummary: z.object({
    accountValue: decimalSchema,
    totalMarginUsed: decimalSchema,
    totalNtlPos: decimalSchema,
    totalRawUsd: decimalSchema,
  }),
  time: z.number(),
  withdrawable: decimalSchema,
})
